import React__default from "react";
const Google = React__default.lazy(() => import("./Google.js"));
const Yandex = React__default.lazy(() => import("./Yandex/index.js"));
const COMPONENT_MAPPINGS = {
  google: Google,
  yandex: Yandex
};
const getMapComponent = (provider) => {
  return COMPONENT_MAPPINGS[provider];
};
export {
  getMapComponent
};
//# sourceMappingURL=index.js.map
